<tt-tabs #tabs>
    <tt-tab *ngFor="let item of webpageSettingTypes; trackBy: trackBy" [ttId]="item.item_id" [ttLabel]="item.item_name" ttTranslateLabel="false" [ttIcon]="item.item_glyphicon"></tt-tab>
</tt-tabs>
<ng-container *ngFor="let item of webpageSettingTypes; trackBy: trackBy">
    <div [hidden]="'' + tabs.ttSelectedId !== '' + item.item_id" class="webpagesettingmenu__tabcontent" *ngIf="!!tabContents['' + item.item_id]">
        <ng-container *ngComponentOutlet="tabContents['' + item.item_id].component; injector: tabContents['' + item.item_id].injector"></ng-container>
    </div>
</ng-container>
